    
import UtilID from "./UtilID";

export default class UtilFile{

    static openFileInNewWindow = (file) => {
        
        if(this.isNotFile(file)){
            return;
        }

        try {

            const fileURL = URL.createObjectURL(file);

            window.open(fileURL, '_blank', 'noopener,noreferrer');

            setTimeout(() => {
                URL.revokeObjectURL(fileURL);
            }, 10000);

        } catch (error) {

            console.error('Erro ao abrir arquivo em nova janela:', error);

        }

    }

    static isFile = (file) => {

        if(file === null){
            return false;
        }

        if(file === undefined){
            return false;
        }

        if(!(file instanceof File)){
            return false;
        }

        return true;

    }

    static isNotFile = (file) => {

        return !this.isFile(file);

    }

    static uniqueFileName = (fileName = "") => {

        // Regex match: baseName e extension
        const match = fileName.match(/^(.*?)(\.[^.]*)?$/);

        const baseName = match[1] || "";
        const extension = match[2] || "";

        const id = UtilID.generateDateTimeID();
        
        return `${baseName}_${id}_${extension}`;

    }

    static mountInvalidBase64 = () => {

        const id = UtilID.generateDateTimeID();

        return {
            fileName: `InvalidFile_${id}`,
            base64: "data:application/octet-stream;base64,",
        };

    }

    static mountBase64 = (options = {}) => {

        const {
            fileName = '',
            base64 = '',
        } = options;

        if (!fileName || !base64) {
            return this.mountInvalidBase64();
        }

        return {
            fileName: this.uniqueFileName(fileName),
            base64,
        };

    }

    static oneToBase64 = (file) => {


        if(this.isNotFile(file)){
            return this.mountInvalidBase64();
        }

        return new Promise((resolve, reject) => {

            const reader = new FileReader();

            reader.onload = () => {

                let result = this.mountBase64({
                    fileName: file?.name || "",
                    base64: reader?.result || "",
                })

                resolve(result);

            };

            reader.onerror = () => {

                reject(reader.error);

            };

            reader.readAsDataURL(file);

        });

    }

    static manyToBase64 = async (files = []) => {

        const results = [];

        for (const file of files) {
            const result = await this.oneToBase64(file);
            results.push(result);
        }

        return results;
        
    }

}
